import { useCallback, useState } from 'react';

const noop = () => {
  // Empty
};

export const useRadioButton = (defaultValue: string, onSave: any = noop) => {
  const [value, setValue] = useState(defaultValue);

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const radioValue = event.target.value;
      setValue(radioValue);
      onSave(radioValue);
    },
    [onSave]
  );

  return {
    onChange,
    value,
  };
};

export const useRadioButtonWithValidate = (defaultValue = '') => {
  const [value, setValue] = useState(defaultValue);
  const [showError, setShowError] = useState(false);

  const onChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const radioValue = event.target.value;
    setValue(radioValue);
    setShowError(false);
  }, []);

  const validate = useCallback(() => {
    if (!value) {
      setShowError(true);

      return false;
    }
    return true;
  }, [value]);

  return {
    onChange,
    value,
    showError,
    validate,
    setValue,
  };
};
